import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API } from '../config';
import './Auth.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-stars">
        {[...Array(10)].map((_, i) => <div key={i} className="auth-star" />)}
      </div>
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src="/JobLinkedAI.png" alt="JobLinked AI" style={{ height: '80px', marginBottom: '1rem' }} />
          </Link>
          <h2>Forgot Password</h2>
          <p>Enter your email and we'll send you a reset link</p>
        </div>

        {submitted ? (
          <div style={{ textAlign: 'center', padding: '1rem 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📧</div>
            <p style={{ color: '#475569', lineHeight: 1.7 }}>
              If that email is registered, a reset link is on its way. Check your inbox.
            </p>
            <div className="auth-footer" style={{ marginTop: '1.5rem' }}>
              <Link to="/login">Back to Sign In</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="your@email.com"
              />
            </div>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn btn-full" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
            <div className="auth-footer">
              <Link to="/login">Back to Sign In</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
